import { render, staticRenderFns } from "./ConsumablesLogs.vue?vue&type=template&id=7a6b9d62&scoped=true"
import script from "./ConsumablesLogs.vue?vue&type=script&lang=js"
export * from "./ConsumablesLogs.vue?vue&type=script&lang=js"
import style0 from "./ConsumablesLogs.vue?vue&type=style&index=0&id=7a6b9d62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b9d62",
  null
  
)

export default component.exports